import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";
import { formatApiError } from "@/api";
import api from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { FilePicker } from "@/components/FilePicker";
import { Label } from "@/components/ui/label";
import { AuthLayout } from "@/pages/Login";

export default function Register() {
  const { register, refresh } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    if (!photo) {
      setError(t("photo.required"));
      setLoading(false);
      return;
    }
    try {
      await register(form.name, form.email, form.password);
      if (photo) {
        const fd = new FormData();
        fd.append("file", photo);
        await api.post("/users/me/photo", fd);
        await refresh();
      }
      navigate("/painel");
    } catch (err) {
      setError(formatApiError(err, t));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title={t("auth.registerTitle")} testid="register-page">
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label htmlFor="name">{t("auth.name")}</Label>
          <Input id="name" data-testid="register-name-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5 h-12 rounded-xl" />
        </div>
        <div>
          <Label htmlFor="email">{t("auth.email")}</Label>
          <Input id="email" data-testid="register-email-input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5 h-12 rounded-xl" />
        </div>
        <div>
          <Label htmlFor="password">{t("auth.password")}</Label>
          <PasswordInput id="password" data-testid="register-password-input" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5 h-12 rounded-xl" />
        </div>
        <div>
          <Label htmlFor="photo">{t("photo.title")}</Label>
          <FilePicker id="photo" testid="register-photo-input" buttonTestid="register-photo-button" file={photo} onChange={setPhoto} />
        </div>
        {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}
        <Button data-testid="register-submit-button" type="submit" disabled={loading} className="w-full h-12 rounded-full bg-accent hover:bg-accent/90 text-white font-semibold">{t("auth.registerBtn")}</Button>
      </form>
      <p className="text-sm text-slate-500 mt-6 text-center">
        {t("auth.hasAccount")}{" "}
        <Link to="/entrar" data-testid="register-to-login" className="text-accent font-semibold hover:underline">{t("auth.loginTitle")}</Link>
      </p>
    </AuthLayout>
  );
}
